// JS-1149 (DESK-012): the read-only desk-rules strip.
//
// ONE component, rendered by BOTH the internal screener table and the edition
// page, so the two surfaces can never drift into saying the desk's thresholds
// differently. Purely presentational: it takes an already-parsed row and reads
// the rules block the sweep recorded on it. No fetch, no state, and nothing
// here recomputes a threshold -- the numbers are exactly what judged the ideas
// on screen.

import {
  deskRulesPanelForRows,
  type DeskRulesPanelSource,
} from "@/domains/trade-ideas/lib/deskRulesPanel";

export function DeskRulesStrip({
  rows,
}: {
  rows:
    | ReadonlyArray<{ desk008_gate_evidence?: DeskRulesPanelSource | null }>
    | null
    | undefined;
}) {
  // Takes the WHOLE displayed list, not one row: a curated page can span a
  // rules activation, and labelling all of it from the first idea would claim
  // a policy that did not judge some of them. See deskRulesPanelForRows.
  const panel = deskRulesPanelForRows(rows);
  // No idea on the page can say what judged it -> the strip renders nothing,
  // rather than claiming house defaults it has no evidence for.
  if (!panel || panel.items.length === 0) return null;

  return (
    <div
      className="flex flex-wrap items-baseline gap-x-2 gap-y-1 border-b border-border bg-surface px-5 py-2"
      data-testid="desk-rules-strip"
    >
      <span className="font-mono text-[9px] font-semibold uppercase tracking-[0.09em] text-muted-foreground">
        {panel.title}
      </span>
      <span className="font-mono text-[10.5px] text-muted-foreground">
        {panel.items.join(" · ")}
      </span>
      {panel.hashShort && (
        <span
          className="ml-auto font-mono text-[9px] text-muted-foreground"
          title={panel.hash ?? undefined}
        >
          {panel.hashShort}
        </span>
      )}
    </div>
  );
}
